import * as React from 'react';
import { connect } from 'react-redux';
import { postToController } from '../../actions/apiActions';
import { updateLifeContact } from "../../actions/lifePolicyActions";
import ProfileNavDesktop from '../ProfileNavigation/ProfileNavDesktop';
import './PersonalDetails.css';

class LifePersonalDeets extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            previous: {},
            editing: false,
            name: "",
            surname: "",
            idNumber: "",
            personalPolicyNo: "",
            livinPolicyNo: "",
            email: "",
            phoneMobile: "",
            alternatePhoneMobile: "",
            address: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        
        this.editInfo = this.editInfo.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.getLanguages = this.getLanguages.bind(this);
        this.handlePreferredLanguageDropdownToggle = this.handlePreferredLanguageDropdownToggle.bind(this);
        this.handlePreferredLanguageSelection = this.handlePreferredLanguageSelection.bind(this);
    }

    async componentDidMount() {
        this.setState({
            ...this.state,
            phoneMobile: this.props.lifePolicy.policy.contact.phoneMobile,
            alternatePhoneNumber: this.props.lifePolicy.policy.contact.alternatePhoneNumber,
            email: this.props.lifePolicy.policy.contact.email,
        });
    }
    
    async getLanguages() {
        await postToController(this.props.dispatch, 'GetLanguages', JSON.stringify({ Parameter: 244 })).then(async (response) => {
            await this.setState({ languageList: response });
            return true;
        })
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async editInfo(e: any) {
        await this.setState({ editing: true, previous: { ...this.state} });
    }

    async cancelEdit(e: any) {
        await this.setState({ editing: false, ...this.state.previous });
    }
    
    async handleSave() {
        this.props.dispatchUpdateLifeContact({
            phoneMobile: this.state.phoneNumber,
            alternatePhoneMobile: this.state.alternatePhoneMobile,
            email: this.state.email
        });
        await this.setState({ editing: false });
    }
    
    async handlePreferredLanguageSelection(e: any) {
        await this.setState({ editPreferredLanguage: e });
    }

    async handlePreferredLanguageDropdownToggle(e: any) {
        await this.setState({
            preferredLanguageDropdownOpen: !this.state.preferredLanguageDropdownOpen
        });
    }

    public render() {
        const policy = this.props.lifePolicy.policy;
        const profile = policy.contact;

        return (
            <>
                <div id="PersonalDetailCard">
                    <div className="col-12 px-0 pb-lg-3">
                        <div className="p-2 text-lg-right invisible">
                            <p className="Last-updated">Last updated: <span>-- -- -- --</span></p>
                        </div>
                        <div className="container-fluid">
                            <div className="text-center">
                                <ProfileNavDesktop />
                                {!this.state.editing &&
                                    <div className="col-12 mt-3 mb-3">
                                        <button className="btn btn-outline-red" onClick={this.editInfo} id='EditPersonalInfo'>Edit details</button>
                                    </div>
                                }
                                {this.state.editing &&
                                    <div className="">
                                        <div className="col-12 mt-3 mb-3">
                                            <button className="btn btn-outline-red mr-lg-3 mb-2 ml-2" onClick={this.cancelEdit} id='CancelPersonalEdit'>Cancel edit</button>
                                            <button className="btn btn-outline-red mt-lg-0 mb-2 ml-2" onClick={this.handleSave} id='SavePersonalEdit'>Save changes</button>
                                        </div>
                                    </div>
                                }
                            </div>
                            <hr />
                            <div className="">
                                <h3 className="Personal-information">Personal details</h3>
                            </div>
                            
                            {profile.name &&
                                <div className="life-personal-details__detail">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Name</p>
                                        <p className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.name}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.surname &&
                                <div className="life-personal-details__detail">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Surname</p>
                                        <p className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.lastName}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.dateOfBirth &&
                                <div className="life-personal-details__detail">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Date of birth</p>
                                        <p className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.dateOfBirth}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.idNumber &&
                                <div className="life-personal-details__detail">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">ID no.</p>
                                        <p className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.idNumber}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {this.props.profile.selectedPersonalPolicy !== undefined &&
                                <>
                                    {this.props.profile.selectedPersonalPolicy.length > 0 && this.props.profile.selectedPersonalPolicy.policyNumber &&
                                        <div className="life-personal-details__detail">
                                            <div className="row">
                                                <p className="col-6"><b>Policy no.</b></p>
                                                <p className="col-6"><b>{this.props.profile.selectedPersonalPolicy.policyNumber}</b></p>
                                            </div>
                                            <hr className="d-block d-lg-none d-md-none" />
                                        </div>
                                    }
                                </>
                            }
                            {<>
                                    {policy?.name &&
                                        <div className="life-personal-details__detail">
                                            <div className="row">
                                                <p className="col-6">Livin' policy no.</p>
                                                <p className="col-6 text-lg-right"><b>{policy.name}</b></p>
                                            </div>
                                            <hr className="d-block d-lg-none d-md-none" />
                                        </div>
                                    }
                                </>
                            }
                                <div className="life-personal-details__detail">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Phone no.</p>
                                            { !this.state.editing && <p className="col-lg-6 col-12 Personaldeets text-lg-right">
                                                <b>{profile.phoneMobile}</b>
                                                <span onClick={this.editInfo} className="life-personal-details__detail">
                                                    <img src="/my-policy/Images/Claims/Edit-pen.png" />
                                                </span>
                                            </p> }
                                            { this.state.editing && <div className="container col-lg-6 col-12 mb-2 ">
                                                <input type='text' className="form-control text-lg-right" value={this.state.phoneMobile} name="phoneMobile" onChange={this.handleChange}></input>
                                            </div> }
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                                <div className="life-personal-details__detail">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Alternative contact no.</p>
                                            { !this.state.editing && <p className="col-lg-6 col-12 Personaldeets text-lg-right">
                                                <b>{profile.alternatePhoneMobile}</b>
                                                <span onClick={this.editInfo} className="life-personal-details__detail">
                                                    <img src="/my-policy/Images/Claims/Edit-pen.png" />
                                                </span>
                                            </p> }
                                            { this.state.editing && <div className="container col-lg-6 col-12 mb-2 ">
                                                <input type='text' className="form-control text-lg-right" value={this.state.alternatePhoneMobile} name="alternatePhoneMobile" onChange={this.handleChange}></input>
                                            </div> }
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                                <div className="life-personal-details__detail">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Email</p>
                                            { !this.state.editing && <p className="col-lg-6 col-12 Personaldeets text-lg-right">
                                                <b>{profile.email}</b>
                                                <span onClick={this.editInfo} className="life-personal-details__detail">
                                                    <img src="/my-policy/Images/Claims/Edit-pen.png" />
                                                </span>
                                            </p> }
                                            { this.state.editing && <div className="container col-lg-6 col-12 mb-2 ">
                                                <input type='text' className="form-control text-lg-right" value={this.state.email} name="email" onChange={this.handleChange}></input>
                                            </div> }
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Suburb</p>
                                        <p className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            {profile.occupation &&
                                <div className="">
                                    <div className="col-12 row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Occupation</p>
                                        <p className="col-lg-6 col-12 pl-0 Personaldeets text-lg-right"><b>{profile.occupation}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.maritalStatus &&
                                <div className="">
                                    <div className="col-12 row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Marital status:</p>
                                        <p className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.maritalStatus}</b></p>
                                    </div>
                                </div>
                            }

                            {/*<div className="row">*/}
                            {/*    <ul>*/}
                            {/*        {!profile.maritalStatus && this.state.isInEdit &&*/}
                            {/*            <li className="mt-2" onClick={this.showFieldUpdate} id={FIELD_PREFERREDLANGUAGE}><Image src='/Images/PersonalDetails/icon-plus-light-green.png' id={FIELD_PREFERREDLANGUAGE} className="img-fluid mr-2" />Add occupation</li>*/}
                            {/*        }*/}
                            {/*    </ul>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        lifePolicy: state.lifePolicy,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        // dispatchPersistDebitOrderDate: (date) => dispatch(updateDebitOrderDate(date)),
        dispatchUpdateLifeContact: (contact) => dispatch(updateLifeContact(contact)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifePersonalDeets);